/**
 * Checks if a title was auto-generated or manually customized
 *
 * @param currentTitle The title to check
 * @param expectedTitle The expected auto-generated title
 * @returns True if the title appears to be auto-generated
 */
export function isAutoGeneratedTitle(
  currentTitle: string | null | undefined,
  expectedTitle: string | null
): boolean {
  if (!currentTitle || !expectedTitle) {
    return false;
  }
  return currentTitle === expectedTitle;
}
